import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import Syllabus from "../Layouts/SyllabusForm";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import { SyllabusFormValues } from "src/models/Syllabus.model";
import {
  useGetSyllabusByIdQuery,
  useUpdateSyllabusByIdMutation,
} from "src/services/SyllabusService";

type Props = {
  onClose: () => void;
  selectedSyllabusId: string;
};

const EditSyllabusWrapper = ({ onClose, selectedSyllabusId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetSyllabusByIdQuery(selectedSyllabusId);
  const [updateSyllabusById] = useUpdateSyllabusByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);
  const initialValues: SyllabusFormValues = {
    syllabusName: items?.syllabusName || "",
    order: items?.order || "",
  };
  // Validation Schema
  const validationSchema = object().shape({
    syllabusName: string().required("Please enter Syllabus name"),
    order: string().required("Please enter order"),
  });

  // Handle Submit
  const handleSubmit = (
    values: SyllabusFormValues,
    { setSubmitting, resetForm }: FormikHelpers<SyllabusFormValues>
  ) => {
    const payload = {
      syllabusName: values.syllabusName,
      order: Number(values.order),
    };
    updateSyllabusById({ id: selectedSyllabusId, body: payload }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Syllabus
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditSyllabusWrapper;
